/* eslint-disable @typescript-eslint/no-explicit-any */
import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/login',
    name: 'login_name',
    meta: {
      title: '数据运营平台'
    },
    component: () => import('@/views/login/index.vue')
  }, {
    path: '/callback/page',
    name: 'callback_page',
    meta: {
      title: '聚光回调'
    },
    component: () => import('@/views/callbackPage/index.vue')
  },
  {
    path: '/404',
    name: '404',
    meta: {
      title: '无权限'
    },
    children: [],
    component: () => import('@/views/noPermission/index.vue')
  },
  {
    path: '/',
    redirect: '/toBeDone'
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
